import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
// import {

// } from "../redux/selectors";
// import {} from "../redux/actions";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardHeader from "@material-ui/core/CardHeader";
// import CardContent from "@material-ui/core/CardContent";
// import Input from "@material-ui/core/Input";
// import InputLabel from "@material-ui/core/InputLabel";
// import FormControl from "@material-ui/core/FormControl";
import { hot } from "react-hot-loader";

function getModalStyle() {
    return {
        top: `50%`,
        left: `50%`,
        transform: `translate(-50%, -50%)`,
        overflow: "visible"
    };
}

const styles = theme => ({
    paper: {
        position: "absolute",
        width: theme.spacing.unit * 55,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit,
        overflow: "visible"
    },

    margin: {
        margin: theme.spacing.unit
    }
});

class ConfirmationModal extends React.Component {
    // constructor(props) {
    //     super(props);
    // }

    render() {
        const { classes } = this.props;

        return (
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={this.props.open}
                onClose={this.props.handleClose}
            >
                <Card style={getModalStyle()} className={classes.paper}>
                    <CardHeader title={this.props.title} />

                    <CardActions
                        className={classes.actions}
                        disableActionSpacing
                    >
                        <Button
                            href="#text-buttons"
                            className={classes.button}
                            onClick={this.props.handleConfirm}
                        >
                            {this.props.confirmLabel}
                        </Button>
                        <Button
                            href="#text-buttons"
                            className={classes.button}
                            onClick={this.props.handleCancel}
                        >
                            {this.props.cancelLabel}
                        </Button>
                    </CardActions>
                </Card>
            </Modal>
        );
    }
}

export default hot(module)(
    withStyles(styles)(
        connect(
            store => {
                return {};
            },
            {}
        )(ConfirmationModal)
    )
);
